export const isBonusAvailable = (bet) => {
    return (bet.freeBetAmount && bet.freeBetAmount > 0)
        || (bet.comboBonusWinningsAmount && bet.comboBonusWinningsAmount > 0)
        || bet.taxes.length > 0;
};
//# sourceMappingURL=isBonusAvailable.js.map